import React from 'react';
import {Link} from "react-router-dom";
import {concepts} from "fearless-common";
import {Accordion} from "react-bootstrap";
import Header from "../../components/Header";
import {routes} from "../../utils/routes";
import styles from './SecurityPage.module.scss';
import Description from "../../components/Description";
import TwoFactorAuthenticationSummary from "../2fa/partials/TwoFactorAuthenticationSummary";
import LoggedInDevices from "../partials/LoggedInDevices";
import Pages from "../../components/layout/Pages";
import useTitle from "../../components/hooks/useTitle";
import headerToTitle from "../../utils/headerToTitle";
import useAuth from "../../components/hooks/useAuth";

const header = [
    { label: 'My Account'},
    { label: concepts.Security },
];
/**
 * The page on which the user can view some security information (e.g. logged in devices)
 * or manage security related things, such as multi-factor authentication.
 */
export default function SecurityPage() {
    const { user} = useAuth();
    useTitle(headerToTitle(header.map(h => h.label)))
    return (
        <Pages.UserBase header={header}>
            <Header component="h3">Password</Header>
            <Description>
                If you want to change your password, please click&nbsp;
                <Link to={routes.forgotPassword+'?email='+encodeURI(user?.email || '')} className="btn-link">here</Link>.
            </Description>

            <Header component="h3" className="mt-5">Two-factor Authentication</Header>
            <Description maxWidth={600}>Two-factor authentication adds an additional layer of security to your account by requiring more than
                just a password to sign in.</Description>
            <TwoFactorAuthenticationSummary />

            <Accordion className="mt-5" defaultActiveKey="">
                <Accordion.Item className="border-start-0 border-end-0" eventKey="logged-in-devices">
                    <Accordion.Header className={styles.LoggedInDevicesHeader}>
                        <h3 className="my-0 py-0 line-height-1-0">Logged-in devices</h3>
                    </Accordion.Header>
                    <Accordion.Body className="px-0">
                        <p>This is a list of devices that have logged into your account. Please revoke any sessions that you do
                            not recognize.</p>
                        <LoggedInDevices />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

        </Pages.UserBase>
    );
}
